import { makeStyles } from 'tss-react/mui';

const name = 'VrpcNote';

export const useVrpcNoteStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));
